import uploadApi from './UploadApi.js';

export default {
	uploadFile: async (formData) => {
		return await uploadApi().post('/v1/caseLawDigestAttachments/uploadFile',
			formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	}
}